import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  currentFees: 'Current Fees',
  connectCost: 'Connect Cost: <tag>{{value}} EGP </tag> ',
  totalCost: 'Total Cost: <tag> {{value}} EGP </tag>',
  remainingCostNote:
    'The remaining total cost <tag>({{value}}ج.م)</tag> will be deducted automatically if the client accepts the contact request.',
  already_sent_to_user: 'Request already sent to user ',
  readyBrokerTitle: 'A verified broker is ready to assist you.',
  helloUser: 'Hello {{user}}!',
  readyBrokerMessage:
    'There is a verified broker on Aqarmap who is interested in helping you with your property search in ({{location}}).',
  listingsCount: '{{count}} listings on aqarmap',
  confirmNote:
    'By clicking the approval button below, the request will be accepted and your information will be shared with this agent only so they can contact you.',
  acceptText: 'Accept Request and Share Your Information',
  cancelText: 'No, Thank you.',
  proposalAccepted:
    'The request has been successfully accepted, and your information will be shared with the broker.',
  lead_request_already_sent: 'Connect request already sent before ',
  acceptRequest: 'Accept Request',
});
